/**
 * @file api.ts
 * @description Platform-aware file API bridge resolver.
 * Delegates to specialized sub-modules for Tauri or Web environments.
 */

import type { AppFileAPI } from '@hcie/core';
import { buildTauriApi } from './api/tauri';
import { buildWebFallbackApi } from './api/web';

declare global {
  interface Window {
    __TAURI__?: any;
    electronAPI?: AppFileAPI;
    lastSelectedFile?: File;
    lastFileName?: string;
    api: AppFileAPI;
  }
}

/**
 * Resolves the appropriate file API based on the current environment.
 */
function resolveApi(): AppFileAPI {
  // 1. Tauri Environment
  if (window.__TAURI__) {
    console.log('[API] Tauri environment detected.');
    return buildTauriApi();
  }

  // 2. Electron Environment (Legacy/Secondary)
  if (window.electronAPI) {
    console.log('[API] Electron API detected.');
    const elApi = window.electronAPI;
    (elApi as any).isDesktop = true;
    return elApi;
  }

  // 3. Web Browser Fallback
  console.warn('[API] Desktop environment not detected. Using Web fallback.');
  return buildWebFallbackApi();
}

/**
 * Unified API instance for the application.
 */
export const api: AppFileAPI = resolveApi();

